import { Link, Typography, useBreakpoint, } from '@one-thd/sui-atomic-components';
import React, { Fragment, useState } from 'react';
export var Breadcrumbs = function (_a) {
    var routes = _a.routes;
    var _b = useState(false), expandCrumbs = _b[0], setExpandCrumbs = _b[1];
    var isDesktop = useBreakpoint('sm').greater;
    var isMobile = !isDesktop;
    var totalArrayLength = routes.length - 1;
    var renderTruncatedText = function (route, index) {
        if (index < totalArrayLength - 2) {
            return null;
        }
        if (index < totalArrayLength - 1) {
            return (React.createElement(React.Fragment, null,
                React.createElement("div", { className: "sui-cursor-pointer" },
                    React.createElement(Typography, { color: "subtle", decoration: "underline", onClick: function () { return setExpandCrumbs(true); }, variant: "body-base" }, "...")),
                totalArrayLength !== index && React.createElement(Typography, null, " / ")));
        }
        return (React.createElement(React.Fragment, null,
            React.createElement(Link, { href: route.path, color: "subtle", variant: "body-base" }, route.label),
            totalArrayLength !== index && React.createElement(Typography, null, " / ")));
    };
    return (React.createElement("div", { className: "sui-flex sui-gap-4 ".concat(isMobile && expandCrumbs
            ? 'sui-overflow-x-scroll sui-whitespace-nowrap sui-pb-1'
            : 'sui-whitespace-nowrap'), "data-testid": "breadcrumbs" }, routes.map(function (route, index) {
        return (React.createElement(Fragment, { key: index }, totalArrayLength !== index ? (React.createElement(React.Fragment, null, routes.length < 4 || expandCrumbs || isDesktop ? (React.createElement(React.Fragment, null,
            React.createElement(Link, { href: route.path, color: "subtle", variant: "body-base" }, route.label),
            totalArrayLength !== index && React.createElement(Typography, null, " / "))) : (renderTruncatedText(route, Number(index))))) : (React.createElement(Typography, { color: "subtle", variant: "body-base" }, route.label))));
    })));
};
